"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromoBadge_1 = require("./PromoBadge");
exports.default = PromoBadge_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/PromoBadge/index.js
// module id = 1803
// module chunks = 8